export class Prepaidcase {
    Id                                           :number; 
    SavingsId                                    :number; 
    PrepaidCaseDate                              :string; 
    IsPrepaidCase                                :boolean;
    
    EmployeeId                                   :number; 
    EmployeeBranchId                             :number; 
    CompanyId                                    :number; 
    SaasId                                       :number;  
    IsActive                                     :boolean; 
    Flag                                         :number;
    ToDate                                       :string
}
